import React, { useCallback, useEffect, useState } from 'react';
import UpdateCompanyLogoModal from '../components/UploadCompanyLogo';
import UpdatePasswordModal from '../components/UpdatePassword';
import UpdateProfileModal from '../components/UpdateProfile';
import Breadcrumb from '../../dashboard/pages/components/BreadCrumb';
import errorHandler from '../../../utils/errorHandler';
import api from '../../../services/api/axiosConfig';

const CPAProfilePage = () => {

  const [profile, setProfile] = useState({ user: {}, business: {} });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null); // For delete success messages



  const fetchProfileInfo = useCallback(async () => {
    setLoading(true);
    setError(null);
    setSuccessMessage(null);

    try {
      const response = await api.get('/profile');
      if (response.data.success) {
        setProfile(response.data.data);
      } else {
        setError(response.data.message || 'Failed to fetch profile from API.');
      }
    } catch (err) {
      errorHandler(err, setError);
    } finally {
      setLoading(false);
    }
  }, []);


  useEffect(() => {
    fetchProfileInfo();
  }, [fetchProfileInfo]);


  // States for controlling the visibility of each modal
  const [showUpdateProfileModal, setShowUpdateProfileModal] = useState(false);
  const [showUpdateLogoModal, setShowUpdateLogoModal] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);

  const breadcrumbItems = [
    { label: 'Dashboard', url: '/dashboard' },
    { label: 'CPA Profile', url: '' }
  ];

  // Initial data for the profile form (you'd typically fetch this from an API)


  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <Breadcrumb items={breadcrumbItems} />


      {/* Profile Header Section */}
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between border-b pb-6 mb-6">
        <div className="flex items-center space-x-4 mb-4 md:mb-0">
          {/* User Profile Image */}
          <div className="w-16 h-16 bg-gray-300 rounded-full flex items-center justify-center overflow-hidden">
            <img
              src={profile.business.logo_url}
              alt="Profile"
              className="w-full h-full object-cover"
              onError={(e) => { e.target.onerror = null; e.target.src = ''; }}
            />
          </div>
          {/* User Details */}
          <div className="flex flex-col">
            <h2 className="text-2xl font-bold ">{profile.business.business_name}</h2>
            <p><span>{profile.user.email || '-'}</span></p>
            <p><span>{profile.user.phone || '-'}</span></p>

          </div>
        </div>
        {/* Profile Action Buttons - now open modals */}
        <div className="flex flex-wrap gap-2 md:gap-3">
          <button
            onClick={() => setShowUpdateProfileModal(true)}
            className="px-4 py-2 bg-primary-brand text-white rounded-md hover:bg-primary-brand-darker transition-colors shadow-sm"
          >
            Update Profile
          </button>
          <button
            onClick={() => setShowUpdateLogoModal(true)}
            className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-700 transition-colors shadow-sm"
          >
            Update Image
          </button>
        </div>
      </div>

      {/* Phone Number Verification Alert */}
      <div className="bg-red-100 border-l-4 border-red-500 p-4 rounded-lg flex items-center justify-between mb-8 shadow-md" role="alert">
        <div className="flex items-center space-x-3">

          <p className="font-semibold text-sm md:text-base">
            Change Password
            <span className="block text-xs md:inline ml-0 md:ml-1 ">
              Change your password to keep your account secure. Make sure to choose strong and unique password.
            </span>
          </p>
        </div>
        <button
          onClick={() => setShowChangePasswordModal(true)}

          className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-700 transition-colors shadow-sm">
          Change now
        </button>
      </div>


      {/* Render the individual modals */}
      <UpdateProfileModal
        isOpen={showUpdateProfileModal}
        onClose={() => setShowUpdateProfileModal(false)}
        initialData={profile}
        onUpdateSuccess={() => {
          fetchProfileInfo();
          setShowUpdateProfileModal(false);
        }}

      />
      <UpdateCompanyLogoModal
        isOpen={showUpdateLogoModal}
        onClose={() => setShowUpdateLogoModal(false)}
        onUpdateSuccess={() => {
          fetchProfileInfo();
          setShowUpdateLogoModal(false);

        }}
      />

      <UpdatePasswordModal
        isOpen={showChangePasswordModal}
        onClose={() => setShowChangePasswordModal(false)}
        onUpdateSuccess={() => {
          setShowChangePasswordModal(false);
        }}
      />
    </div>
  );
};

export default CPAProfilePage;
